import * as React from "react";
const SvgTrendUp20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 12,
        fill: "black",
        viewBox: "0 0 20 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M13 0h7v7h-2V3.414l-7 7-4-4-5.293 5.293-1.414-1.414L7 3.586l4 4L16.586 2H13V0Z",
      clipRule: "evenodd"
    })
  );
export default SvgTrendUp20Px;
